module.exports = __webpack_public_path__ + "b6d649a21f8095f0052e0f10b1d4c54b.jpg";